import * as campaigns from './Campaigns';
import * as blocks from './Blocks';
import * as rows from './Rows';

export const route = {
  path: 'planning',
  children: [campaigns.route, blocks.route, rows.route],
};
